import { FC } from "react";
import { Image, Stack } from "@chakra-ui/react";

import { CoolingPageText } from "./Text";
import { CoolingPageButtons } from "./Buttons";
import { CoolingPageContract } from "./Contract";
import { ICooling } from "../../../api/cooling/types";
import successIcon from "../../../assets/successTick.png";

interface Props {
  limitInfo: ICooling["limitInfo"];
}

export const CoolingPageContent: FC<Props> = ({ limitInfo }) => {
  return (
    <Stack alignItems="center" pt="38px" w="calc(100% - 8px)">
      <Image w="150px" h="84px" src={successIcon} />

      <CoolingPageText limitInfo={limitInfo} />
      <CoolingPageContract limitInfo={limitInfo} />
      <CoolingPageButtons />
    </Stack>
  );
};
